import { getStaticFilesURL } from './getStaticFilesURL';
export var getNothsLogoUrl = function getNothsLogoUrl(env, port) {
  return getStaticFilesURL(env, 'img/logo/NOTHS_logo.svg', port);
};
export var getNothsBlackLogoUrl = function getNothsBlackLogoUrl(env, port) {
  return getStaticFilesURL(env, 'img/logo/NOTHS_logo_black.svg', port);
};